import React from 'react';
import { Timer } from '../../generic/timer/timer';
import PresentationPage from './presentation-page';

export function PresentationPageTimer({ data, presentation }) {
  return <PresentationPage {...{ data, presentation }} Plugin={Timer} />;
}

export default PresentationPageTimer;
